/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown>, group: NonNullable<unknown> }} Error_Shop_Variant_In_Other_GroupInputs */

const vi_error_shop_variant_in_other_group = /** @type {(inputs: Error_Shop_Variant_In_Other_GroupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`SKU ${i?.sku} đang thuộc nhóm "${i?.group}". Gỡ khỏi nhóm đó trước.`)
};

/**

* @param {Error_Shop_Variant_In_Other_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_variant_in_other_group = /** @type {((inputs: Error_Shop_Variant_In_Other_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Variant_In_Other_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_variant_in_other_group(inputs)
});